import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, post } from "../api";
import { API_URL } from "../api";

function useVerifyAddress<T>(
  options?: MutationOptions<APIResponse<T>, APIError, Record<any, any>>
) {
  const {
    isLoading: verifyingAddress,
    isError: isVerifyingAddressError,
    error: verifyingAddressError,
    mutate: verifyAddress,
  } = useMutation((variables: Record<any, any>) => {
    return post(
      API_URL + "/account/verify-user-address",
      variables,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
  }, options);

  return {
    verifyAddress,
    isVerifyingAddressError,
    verifyingAddressError,
    verifyingAddress,
  };
}

export default useVerifyAddress;
